import script from "./VInputSegmented.vue?vue&type=script&lang=ts&setup=true"
export * from "./VInputSegmented.vue?vue&type=script&lang=ts&setup=true"

import "./VInputSegmented.vue?vue&type=style&index=0&id=85abb84e&lang=sass"

const __exports__ = script;

export default __exports__